module.exports = __webpack_public_path__ + "static/media/building.4d83de85.svg";